import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formWrapper: {
      margin: `${theme.spacing(8)} auto 0`,
      maxWidth: "100%",
      width: "872px",
    },
    sectionSubheader: {
      color: theme.gray500,
      fontSize: "14px",
      lineHeight: "20px",
    },
  }),
);
